module.exports = __webpack_public_path__ + "img/stretch--genre2_tab-active.57bef18d.png";